import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LoggerService } from '../../ui/utils';
import { Button, Theme, ButtonSize, ButtonWidth, FrameworkRole, useBreakpoint } from '../../ui/components';
import amwayLogo from '../../assets/image/Amw_Logo_Black.webp';
import { getContent } from '../../sdk/services/contentService';
import styles from './PreLoginPage.module.scss';

interface PreLoginPageProps {
  accessType: FrameworkRole;
  isGame: boolean
}

export const PreLoginPage = ({ accessType, isGame }: PreLoginPageProps) => {
  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm'].indexOf(viewPortType) === -1;
  const [searchParams] = useSearchParams();
  const sourceParam = searchParams.get('source');
  const teamParam = searchParams.get('t');

  const [content, setContent] = useState({
    logo: {
      url: '',
    },
    background_image: {
      url: '',
    },
    background_image_mobile: {
      url: '',
    },
    background_image_position: 'left',
    show_amway_logo: true,
    title: '',
    subtitle: '',
    description: '',
    cta: {
      title: '',
      href: '',
    },
    cta_2: {
      title: '',
      href: '',
    },
    text_content_position: 'center',
  });

  const csKey =  'pre_login_page';
  const cacheKey = 'preLoginContent';

  useEffect(() => {
    const fetchPreLoginContent = async () => {
      
      const path = window.location.pathname.startsWith('/promotions')
        ? '/promotions'
        : '/';

      try {
        const data = await getContent(csKey, cacheKey, true);
        const current = data?.find(
          (c: { link?: { href?: string } }) =>
            c.link?.href === path
        );
        setContent(current);
        
      } catch (error) {
        LoggerService.log('Failed to retrieve content data. Using default content?.');
      }
    };

    fetchPreLoginContent();
  }, []);

  const handleLoginClick = (url: string) => {
    let loginUrl;
    if (url === '/login/redirect' && sourceParam && teamParam) {
      loginUrl = `/login/redirect?source=${sourceParam}&t=${teamParam}`;
    } else {
      loginUrl = url;
    }
    window.location.href = loginUrl;
  };

  return (
    <div className={styles['pre-container']} style={{
        alignItems:
          content?.text_content_position === 'top'
            ? 'flex-start'
            : content?.text_content_position === 'bottom'
              ? 'flex-end'
              : 'center',
      }}>
      <div className={styles['inner-wrapper']}>

        {/* When background_image_position = "left", show image first */}
        {isDesktopView && content?.background_image_position === "left" && (
          <div className={styles['right-image']}>
            <img src={content?.background_image?.url} alt="Background" />
          </div>
        )}

        {/* LEFT CONTENT ALWAYS RENDER, BUT ORDER CHANGES BASED ON POSITION */}
        <div className={styles['left-content']}>
          {content?.show_amway_logo && (<img className={styles['logo']} src={amwayLogo} alt={'Amway Logo'} />)}
          <h1 className={styles['title']}>{content?.title}</h1>
          <h2 className={styles['subtitle']}>{content?.subtitle}</h2>
          <p className={styles['content']}>{content?.description}</p>

          <div className={styles['button-container']}>
            {content?.cta?.title && (
              <Button
                title={content?.cta?.title}
                size={ButtonSize.MEDIUM}
                className={styles['login-button']}
                onClick={() => handleLoginClick(content?.cta?.href)}
                theme={isGame ? Theme.BLACK : Theme.GREEN}
                buttonWidth={isDesktopView ? ButtonWidth.FULL_WIDTH : ButtonWidth.FIT_CONTENT}
              />
            )}
            {content?.cta_2?.title && (
              <Button
                title={content?.cta_2?.title}
                size={ButtonSize.MEDIUM}
                className={styles['login-button']}
                onClick={() => (window.location.href = content?.cta_2?.href)}
                theme={isGame ? Theme.BLACK : Theme.GREEN}
                buttonWidth={isDesktopView ? ButtonWidth.FULL_WIDTH : ButtonWidth.FIT_CONTENT}
              />
            )}
          </div>
        </div>

        {/* When background_image_position = "right", show image after content */}
        {isDesktopView && content?.background_image_position !== "left" && (
          <div className={styles['right-image']}>
            <img src={content?.background_image?.url} alt="Background" />
          </div>
        )}

        {/* MOBILE IMAGE REMAINS SAME */}
        {!isDesktopView && (
          <div className={styles['image-container']}>
            <img
              className={styles['image-background-mobile']}
              src={content?.background_image_mobile.url}
              alt={'Amway Background Mobile'}
            />
          </div>
        )}

      </div>
    </div>
  );
};
